import request from '../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const getErsCheck = query => {   
    var list = request({
        url: 'redis/ersCheck',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 
 